import {Component, Vue} from "vue-property-decorator";
import {ClientNav} from "~/components/nav/client-nav";
import {PartnerNav} from "~/components/nav/partner-nav";

@Component
class Nav extends Vue {
  private get clientUuid() {
    return this.$route.params.clientUuid;
  }

  render() {
    return this.clientUuid ? <ClientNav /> : <PartnerNav />;
  }
}

export { Nav }

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-45f79cf0/index.tsx" });